(function () {
  const tag = 'mz-ble'
  const log = debug(tag)
  log('loaded')  

  if (!navigator.bluetooth) {
    return alert('your browser does not support bluetooth! using device emulator...');
  }

  // -----------------------------------------------------------------
  // BLE
  // -----------------------------------------------------------------
  const filterServiceUuid    = "6e400001-b5a3-f393-e0a9-e50e24dcca9e"
  const serviceUuid = '00000001-0000-1000-8000-00805f9b34fb'
  const sensorTags = {
      '00000001-0000-1000-8000-00805f9b34fb': 'acx',
      '00000002-0000-1000-8000-00805f9b34fb': 'acy',
      '00000003-0000-1000-8000-00805f9b34fb': 'acz',
      '00000004-0000-1000-8000-00805f9b34fb': 'spd',
      '00000005-0000-1000-8000-00805f9b34fb': 'trq',
      '00000006-0000-1000-8000-00805f9b34fb': 'tge',
      '00000007-0000-1000-8000-00805f9b34fb': 'toi',
      '00000008-0000-1000-8000-00805f9b34fb': 'loi',
      '00000009-0000-1000-8000-00805f9b34fb': 'woi',
      '0000000a-0000-1000-8000-00805f9b34fb': 'coi'
  }

  let device = null;
  const connectionTimeout = 30 * 1000
  const notificationTimeout = 10 // [s]

  let connectionTimeoutHandle = null
  let notificationTimeoutHandle = null
  
  const requestDeviceOptions = {
    filters: [
      { services: [filterServiceUuid] }
    ],
    optionalServices: [serviceUuid]
  }

  // -----------------------------------------------------------------

  const mzBleDevice = window.mzBleDevice = {
    connected: false,
    isConnecting: false,
    events: {},
    eventLabels: [
      'connected',
      'disconnected',
      'data',  
    ]
  };

  // init event callbacks
  mzBleDevice.eventLabels.forEach(function(label) {
    mzBleDevice.events[label] = [];
  });

  mzBleDevice.connect = function() {
    log('mzBleDevice#connect')

    _connect();
  };

  mzBleDevice.disconnect = function() {
    log('mzBleDevice#disconnect')

    _disconnect();
  };

  // register events und inject callbacks
  mzBleDevice.on = function(event, eventCallback) {
    if (mzBleDevice.events[event] !== undefined) {
      mzBleDevice.events[event].push(eventCallback);
      return log('event registered: ' + event);
    }

    log('unkown event: ' + event);
  };

  async function _connect() {
    log('_connect')
    try {
      if (device === null) {
        log('requesting bluetooth device...')
        device = await navigator.bluetooth.requestDevice(requestDeviceOptions)
        device.addEventListener('gattserverdisconnected', _disconnectCallback)
      } else {
        log('this seems to be a reconnect...')
        clearTimeout(notificationTimeout)
        notificationTimeoutHandle = null
      }

      mzBleDevice.isConnecting = true;
      connectionTimeoutHandle = setTimeout(() => {
        log('connection timeout! reset isConnecting to false')
        mzBleDevice.isConnecting = false;
      }, connectionTimeout)

      log('connecting to gatt server...')
      const server = await device.gatt.connect()

      log('getting service...')
      const service = await server.getPrimaryService(serviceUuid)

      _connectCallback()

      for (let uuid in sensorTags) {
        log('getting characteristic... ' + sensorTags[uuid])
        const charistic = await service.getCharacteristic(uuid)
  
        log('start notifications...')
        await charistic.startNotifications()
  
        log('add event listener...')
        charistic.addEventListener('characteristicvaluechanged', _notificationCallback)
      }

      log('success')
    } catch (err) {
      device = null
      mzBleDevice.isConnecting = false
      clearTimeout(connectionTimeoutHandle)
      connectionTimeoutHandle = null

      log('_connect: error: ' + err.message)
    }
  }

  function _notificationCallback(event) {
    log('_notificationCallback');

    const uuid = event.target.uuid
    const id = sensorTags[uuid]
    const value = event.target.value.getFloat32(0, true);
    log(id + ': ' + value)

    const msg = {
      timestamp: Date.now(),
      id: id,
      value: value
    }

    mzBleDevice.events.data.forEach(function(cb) {
      cb(msg)
    })

    // start reconnect timmer
    if (notificationTimeout !== null) {
      log('reset notification timeout...')
      clearTimeout(notificationTimeoutHandle)
    }

    notificationTimeoutHandle = setTimeout(() => {
      log('notification timeout!')
      if (device && device.gatt.connected) {
        log('is device connected? YES! try to reconnect...')
        _disconnect()
        _connect()
      } else {
        log('is device connected? NO! no further actions')
      }
    }, notificationTimeout * 1000)
  }

  function _connectCallback() {
    log('_connectCallback');

    clearTimeout(connectionTimeoutHandle)

    mzBleDevice.isConnecting = false;
    mzBleDevice.connected = true;
    mzBleDevice.events.connected.forEach(function(cb) {
      cb();
    });
}

  function _disconnectCallback() {
    log('_disconnectCallback')

    device = null

    mzBleDevice.isConnecting = false;
    mzBleDevice.connected = false;
    mzBleDevice.events.disconnected.forEach(function(cb) {
      cb();
    });
  }


  function _disconnect() {
    log('_disconnect');

    if (device && device.gatt.connected) {
      if (notificationTimeout !== null) {
        log('clear notification timeout...')
        clearTimeout(notificationTimeoutHandle)
      }

      log('bleDevice is connected... will be disconnected soon...')
      return device.gatt.disconnect();
    }

    log('device is already disconnected');      
  }
})()



// WEBPACK FOOTER //
// ./src/lib/ble.js